import { AutoFactory, OnlinePortalProposedLoanStageGroupsApi } from '@sageworks/jpi';

export const fetchProposedLoanStageGroups = async () => {
	const response = await AutoFactory.get(OnlinePortalProposedLoanStageGroupsApi).getAll();

	return response.items ?? [];
};